import useTelemetry from '../hooks/useTelemetry';
import { useDashboardSettings } from '../hooks/useDashboardSettings';
import { useViewport } from '../hooks/useViewport';
import { useMenu } from '../hooks/useMenu';
import useWidgetMenu from '../hooks/useWidgetMenu';
import { TelemetryExpandedModal, getPanelPrimaryParam } from '../../../../../CommonComponents/telemetry';
import { useMemo } from 'react';


const MaximizeModal = () => {
    const {
        activeLayout,
        patchWidget,
        expandedTelemetryPanel,
        setExpandedTelemetryPanel,
    } = useTelemetry();

    const {
        precision,
        units,
        timeframe,
    } = useDashboardSettings();

    const { viewport } = useViewport(timeframe);

    const { menu } = useMenu();
    const { handleVizClickMenu } = useWidgetMenu();

    const currentExpandedPanel = useMemo(() => activeLayout.find((w) => w.id === expandedTelemetryPanel?.id) || expandedTelemetryPanel, [activeLayout, expandedTelemetryPanel]);
    return (
        <TelemetryExpandedModal
            panel={currentExpandedPanel}
            timeframe={timeframe}
            precision={precision}
            units={units}
            viewport={viewport}
            onClose={() => setExpandedTelemetryPanel(null)}
            patchWidget={patchWidget}
            activeMenuTriggerId={menu?.triggerId}
            onVizClick={(e) => {
                if (!currentExpandedPanel) return;
                const primaryParam = getPanelPrimaryParam(currentExpandedPanel);
                handleVizClickMenu(currentExpandedPanel, e, primaryParam.subsystem, primaryParam.paramName);
            }}
        />
    )
}

export default MaximizeModal